<template>
    <path
        d="M2.37062 14.4585L13.4422 3.38686L13.4602 7.5173C13.4653 8.70371 15.2604 8.69589 15.2552 7.50948L15.236 3.74486L15.2231 1.23177C15.2195 0.743648 14.819 0.350032 14.3266 0.350716L7.99549 0.374487C7.75142 0.372252 7.51675 0.468722 7.34631 0.642021C6.77901 1.20946 7.19759 2.17295 8.00323 2.15415L12.1745 2.13119L1.06539 13.2403C0.235312 14.1571 1.57331 15.3428 2.37062 14.4585Z"
    />
</template>
